import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function SelfTalkPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV2.selfTalk.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-orange"
          emoji="😠"
          label={t("pages.onboardingV2.selfTalk.harshly")}
          name={t("pages.onboardingV2.selfTalk.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.selfTalk.harshly", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="😐"
          label={t("pages.onboardingV2.selfTalk.neutrally")}
          name={t("pages.onboardingV2.selfTalk.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.selfTalk.neutrally", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-green"
          emoji="💗"
          label={t("pages.onboardingV2.selfTalk.kindly")}
          name={t("pages.onboardingV2.selfTalk.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.selfTalk.kindly", {
            lng: "en",
          })}
        />
      </Form>
    </Layout>
  )
}
